function b64e(str) {
  return btoa(
    encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) {
      return String.fromCharCode("0x" + p1);
    })
  );
}

function b64d(str) {
  return decodeURIComponent(
    Array.prototype.map
      .call(atob(str), function (c) {
        return "%" + c.charCodeAt(0).toString(16);
      })
      .join("")
  );
}

// Never throws. ContactForm calls this immediately after FormIt has accepted a
// lead, inside the same try/catch that reports submission failures — so a write
// that blew up here (quota exceeded, storage disabled) would show the visitor a
// "we couldn't submit your request" error for a lead that was in fact delivered,
// and skip the conversion event on the way out. Losing the thank-you page's
// name/email echo is the acceptable failure; losing the lead is not.
function setObjectHash(key, myObject) {
  if (typeof window === "undefined") return;

  try {
    if (!window.localStorage) return;

    var newObject = {};
    Object.keys(myObject).map(function (value, index) {
      newObject[value] = b64e(myObject[value]);
    });
    window.localStorage.setItem(key, b64e(JSON.stringify(newObject)));
  } catch (e) {
    /* storage unavailable or full — not worth failing the submission over */
  }
}

// Returns null rather than throwing when the key is absent or unreadable.
//
// The previous version called b64d(myObject) directly on the result of
// getItem(). A missing key returns null, atob(null) happily decodes the string
// "null" into bytes that are not valid UTF-8, and decodeURIComponent then threw
// "URIError: URI malformed". Because /thanks/ reads this during render, the
// throw killed hydration for anyone arriving without a prior submission — the
// server-rendered HTML still painted, so the page looked fine while every
// interactive element on it was dead. Storage can also be unreadable outright
// (Safari private mode, blocked third-party storage), so the whole read is
// wrapped rather than just the null case.
function getObjectHash(key) {
  if (typeof window === "undefined") return null;

  try {
    if (!window.localStorage) return null;

    var stored = window.localStorage.getItem(key);
    if (!stored) return null;

    var decoded = b64d(stored);
    if (!decoded) return null;

    return JSON.parse(decoded, function (key, value) {
      return key ? b64d(this[key]) : this[key];
    });
  } catch (e) {
    return null;
  }
}

export function setItemToLStore(key, data) {
  setObjectHash(key, data);
}

export function getItemFromStore(key) {
  return getObjectHash(key);
}

// // Usage
// var userObject = { userId: 24, name: 'Jac|`` /\Baèéàòùu"aer' };
// document.body.appendChild(document.createTextNode('user: ' + JSON.stringify(userObject)));
// document.body.appendChild(document.createElement('br'));

// document.body.appendChild(document.createTextNode('localStorage.getItem(\'user\'): ' + localStorage.getItem('user')));
// document.body.appendChild(document.createElement('br'));
// document.body.appendChild(document.createTextNode('localStorage.getObject(\'user\').name: ' + localStorage.getObjectHash('user').name));
